import { atom } from 'jotai';

const lzSCommonsFullscreenLogMessageAtom = atom<string>('');

export default lzSCommonsFullscreenLogMessageAtom;
